import { GetURLParameter } from "../../darwin/js/helpers";
import loadingIndicator from "../new-boost/js/loading_indicator";
import showErrorMessage from "../new-boost/js/showErrorMessage";

const arrayOfFilterIds = [
    "campaignFilter",
    "listingsFilter",
    "timeFilter",
    "paidByFilter",
    "exportButton",
];

function enableFilterDropdownButtons() {
    arrayOfFilterIds.forEach((f) => {
        // click handlers to drop down menus when title buttons are clicked
        $("main").on("click", "#" + f + " .status", () => {
            $("#" + f + " .menu").toggle();
            event.stopPropagation();

            // hide the others to ensure we dont' have more than one open
            const menusToHide = arrayOfFilterIds.filter((menu) => menu !== f);
            menusToHide.forEach((m) => $("#" + m + " .menu").hide());
        });
    });

    $("main").on("click", ".filters", (e) => {
        // we need this so the document level doesn't receive any menu click events and close/hide us
        e.stopPropagation();
    });
}

function radioButtonChangeHandler(radioTarget) {
    const newText = radioTarget.data("text-label");

    // update the filter title/status
    const filter = radioTarget.closest(".filter");
    const textToReplace = filter.find(".text-to-replace");
    textToReplace.text(newText);
    if (newText !== "Custom") {
        filter.find(".menu").hide();
    }
}

function setUpRadioButtonsChangeFilter() {
    arrayOfFilterIds.forEach((f) => {
        if (f === "exportButton") {
            return; // skip export, it does its own thing
        }

        // $('#'+f+' input[type=radio]').change((e) => {
        $("main").on("change", "#" + f + " input[type=radio]", (e) => {
            const radio = $(e.target);
            radioButtonChangeHandler(radio);
            if (radio.val() === "custom") {
                validateSendOnDateChange();
            } else {
                // trigger the submission of the form to retrieve new filtered results
                $("#enterprise-dash-form").trigger("submit");
            }
        });
    });
}

function validateSendOnDateChange() {
    const timeFrameToValue = $("#timeFrameToPicker");
    const timeFrameFromValue = $("#timeFrameFromPicker");
    if (
        timeFrameToValue != null &&
        timeFrameToValue.val() != null &&
        timeFrameToValue.val() !== "" &&
        timeFrameFromValue != null &&
        timeFrameFromValue.val() != null &&
        timeFrameFromValue.val() !== ""
    ) {
        $("#enterprise-dash-form").trigger("submit");
    }
}

function setUpDatePickers() {
    const fromDatePickerEl = $("#prettyTimeFrameFromPicker");
    const toDatePickerEl = $("#prettyTimeFrameToPicker");

    // set up of the datepickers for custom date range
    //use this one handler for both Start and End Date pickers
    const onDateSelect = function (selectedDate, input) {
        if (input.id === "prettyTimeFrameToPicker") {
            //Start date selected - update End Date picker
            fromDatePickerEl.datepicker("option", "minDate", selectedDate);
        } else {
            //End date selected - update Start Date picker
            toDatePickerEl.datepicker("option", "maxDate", selectedDate);
        }
        $("#timeFilter .menu").show();
        // trigger the submission of the form to retrieve new filtered results
        // only submit if both time inputs are set
        validateSendOnDateChange();
    };

    fromDatePickerEl.datepicker({
        dateFormat: "m/d/yy",
        onSelect: onDateSelect,
        altField: "#timeFrameFromPicker",
        altFormat: "yy-mm-dd",
    });
    toDatePickerEl.datepicker({
        dateFormat: "m/d/yy",
        onSelect: onDateSelect,
        altField: "#timeFrameToPicker",
        altFormat: "yy-mm-dd",
    });

    $(".filters").on("click", ".date-inputs", (e) => {
        e.stopPropagation(); // this is needed to control whether or not you want to have the menu hide when the calendar pops up
        $("input[name=timeFrame][value=custom]").trigger("click");
    });
}

$(document).click((e) => {
    let clicked = $(e.target);
    console.log(clicked);
    if (
        clicked.hasClass("ui-icon-circle-triangle-w") ||
        clicked.hasClass("ui-icon-circle-triangle-e")
    ) {
        return;
    }
    // some one clicked on NOT a menu - close all menus
    arrayOfFilterIds.forEach((f) => $("#" + f + " .menu").hide());
});

function setupListenerForExportReportButton() {
    // handles the export button press when no params are included in the report data
    $("main").on("click", "#exportButton .export-button", (e) => {
        const exportElement = $(e.target);
        const container = $("#exportButton");
        const leadsOrEngagment = container.find("input:checked");
        const email = container.find("input[name='emailToUse']");

        let href = exportElement.data("engagement-report");
        if ("leads" === leadsOrEngagment.val()) {
            href = exportElement.data("lead-report");
        }

        // Use same filter params we use to display campaign list in darwin
        href += window.location.search;
        if (email != null) {
            const startChar = !href.includes("?") ? "?" : "&";
            href += startChar + "emailToUse=" + encodeURIComponent(email.val());
        }

        initiateReport(href);
        container.find(".menu").hide();
    });

    // handles the export button press with several params to be included in the report data
    $("main").on("click", "#newExportButton .export-button", (e) => {
        const exportElement = $(e.target);
        const container = $("#newExportButton");
        const email = container.find("input[name='emailToUse']");

        let href = exportElement.data("report");

        // Use same filter params we use to display campaign list in darwin
        if (window.location.search.includes("?")) {
            href += "&" + window.location.search.substring(1); // replace ? with &
        }
        if (email != null) {
            const startChar = !href.includes("?") ? "?" : "&";
            href += startChar + "emailToUse=" + encodeURIComponent(email.val());
        }

        initiateReport(href);
    });

    // handles the dropdown menu button press
    $("main").on(
        "click",
        "#newExportButton .email-export-dropdown__dropbtn",
        (e) => {
            document
                .getElementById("myDropdown")
                .classList.add("email-export-dropdown__show");
        },
    );

    // handles the cancel button press in the dropdown
    $("main").on("click", "#exportButton .cancel-button", (e) => {
        const container = $("#exportButton");
        container.find(".menu").hide();
    });
}

// Close the dropdown if the user clicks outside of it
window.onclick = function (event) {
    var element = document.getElementById("myDropdown");
    if (
        element != null &&
        event != null &&
        event.target != null &&
        ((event.target !== element &&
            !element.contains(event.target) &&
            !event.target.matches(".email-export-dropdown__dropbtn")) ||
            event.target.matches(".close-on-click"))
    ) {
        var dropdowns = document.getElementsByClassName(
            "email-export-dropdown__dropdown-content",
        );
        if (dropdowns != null) {
            var i;
            for (i = 0; i < dropdowns.length; i++) {
                var openDropdown = dropdowns[i];
                if (
                    openDropdown != null &&
                    openDropdown.classList != null &&
                    openDropdown.classList.contains(
                        "email-export-dropdown__show",
                    )
                ) {
                    openDropdown.classList.remove(
                        "email-export-dropdown__show",
                    );
                }
            }
        }
    }
};

function initiateReport(endpoint) {
    loadingIndicator.show();
    const exportButton = document.getElementById("customer-export-button");
    exportButton.disabled = true;
    jQuery
        .get(encodeURI(endpoint))
        .success(function (response) {
            exportButton.disabled = false;
            const { success, message } = jQuery.parseJSON(response);

            if (!success) {
                displayReportError(message);
                loadingIndicator.hide();
                return;
            }
            displaySuccess();
            loadingIndicator.hide();
        })
        .fail(function () {
            exportButton.disabled = false;
            displayReportError();
            loadingIndicator.hide();
        });
}

function displaySuccess() {
    const content =
        "Your report has been scheduled. Check your email for the download link. It may take up to 30 minutes for you to receive the email.";
    showErrorMessage(content, false, false, true);
}

function displayReportError($message) {
    var messageInfo = "";
    if ($message !== undefined) {
        messageInfo = " " + $message + ".";
    }
    const content =
        "Oops, there was a problem with your report." +
        messageInfo +
        " If the problem persists reach out to us.";
    showErrorMessage(content, false, false);
}

function initEnterpriseDash() {
    enableFilterDropdownButtons();
    setUpRadioButtonsChangeFilter();
    //setUpDatePickers(); - don't do this - it gets done in the intercooler ready call below
    setupListenerForExportReportButton();
}

function resetTheUiToMatchTheUrl() {
    const selectedTimeFrameFrom = GetURLParameter("timeFrameFrom");
    const selectedTimeFrameTo = GetURLParameter("timeFrameTo");

    if (selectedTimeFrameFrom) {
        $("input[name=prettyTimeFrameFrom]").val(selectedTimeFrameFrom);
        $("input[name=timeFrameFrom]").val(selectedTimeFrameFrom);
    }
    if (selectedTimeFrameTo) {
        $("input[name=prettyTimeFrameTo]").val(selectedTimeFrameTo);
        $("input[name=timeFrameTo]").val(selectedTimeFrameTo);
    }

    const radioNames = ["statuses", "type", "timeFrame", "paidBy"];

    radioNames.forEach((radioName) => {
        const selectedState = GetURLParameter(radioName);
        if (selectedState) {
            let radioTarget = $(
                `input[name=${radioName}][value=${selectedState}]`,
            );
            radioTarget.prop("checked", true);
            radioButtonChangeHandler(radioTarget);
        }
    });
}

$(document).ready(() => {
    resetTheUiToMatchTheUrl(); // this must happen first since I make sure the buttons match the url here, but don't want to trigger a submit
    initEnterpriseDash();
});

// every time we load, we need to see how many campaigns we have showing in the filters
// this will affect how we show the export button
Intercooler.ready((elt) => {
    setUpDatePickers();

    const campaignElems = $(".filteredCampaign");
    if (campaignElems.length > 0) {
        $("#exportButton").css("visibility", "visible");
    } else {
        $("#exportButton").css("visibility", "hidden");
    }
});
